import React from "react";
import Button2 from "./button2.jsx";
import { useSelector } from "react-redux";

function ResultsModal({ isOpen, onClose }) {
  const { daily } = useSelector((state) => state.game);

  // const dailyGame = [
  //   {
  //     id: 1,
  //     title: "Florida man's mugshot hits viral status after arrest",
  //     img: "https://res.cloudinary.com/graham-media-group/image/upload/f_auto/q_auto/c_scale,w_900/v1/production/public/D2MSBP73AFGW3GGST6N2UFSAHQ.jpg?_a=AJFJtWIA",
  //     borderColor: "red",
  //   },
  //   {
  //     id: 2,
  //     title:
  //       "Florida Man Arrested For Practicing Karate By Kicking Swans In The Head",
  //     img: "https://images.deadspin.com/tr:w-1200/og0zy09mv5wv2w2x43wh.jpg",
  //     borderColor: "green",
  //   },
  //   {
  //     id: 3,
  //     title:
  //       "Florida man arrested outside Olive Garden after eating pasta belligerently",
  //     img: "https://whnt.com/wp-content/uploads/sites/20/2019/04/pasta.jpg?w=1200&h=630&crop=1",
  //     borderColor: "blue",
  //   },
  // ];

  if (!isOpen) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "rgba(0,0,0,0.5)",
        zIndex: 1000,
      }}
    >
      <div
        style={{
          padding: 20,
          background: "white",
          borderRadius: "15px",
          boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
          maxWidth: "80%",
          maxHeight: "90%",
          overflowY: "auto",
        }}
      >
        <p>Here are the correct combinations...</p>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "20px",
          }}
        >
          {daily.map((game) => (
            <div
              key={game.id}
              style={{
                border: `5px solid orange`,
                display: "flex",
                flexDirection: "row",
                padding: "10px",
                borderRadius: "20px",
              }}
            >
              <img
                src={game.img}
                alt={game.title}
                style={{
                  width: "100px",
                  height: "120px",
                  margin: "10px",
                  objectFit: "cover",
                  objectPosition: "50% 50%",
                  borderRadius: "20px",
                }}
              />
              <h4>{game.title}</h4>
            </div>
          ))}
        </div>
        <div style={{ marginTop: "20px" }}>
          <Button2 onClick={onClose}>Close</Button2>
        </div>
      </div>
    </div>
  );
}

export default ResultsModal;
